'use client'

import { Button } from '@/app/components/ui/button';
import { ChevronLeftIcon } from '@radix-ui/react-icons';
import { useRouter } from 'next/navigation';
import React from 'react';

const BackButton = () => {
  const router = useRouter();
  return (
    <Button variant="outline" size="icon" onClick={() => router.back()}>
      <ChevronLeftIcon className="h-4 w-4" />
    </Button>
  );
}

export default BackButton
